import { createRequest } from "helpers/tools";

export const deleteTrackerEventsAsync = async (id) => {
  return await createRequest({
    suffix: `events/${id}`,
    method: "delete",
    handleError: false,
  });
};
